export default "__VITE_ASSET__CH01LJvN__"